import { render } from "./search-page.vue?vue&type=template&id=6bc232b4&scoped=true"
import script from "./search-page.vue?vue&type=script&lang=js"
export * from "./search-page.vue?vue&type=script&lang=js"

import "./search-page.vue?vue&type=style&index=0&id=6bc232b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc232b4"]])

export default __exports__